export default {
  setUserID: "setUserID",
  getMeInfo: "getMeInfo",
  getProjects: "getProjects",
  setProjectID: "setProjectID",
  fetchProjectDetails: "fetchProjectDetails",
  addTask: "addTask",
  setAdding: "setAdding",
  fetchProjectInfo: "fetchProjectInfo",
  setAllAddingFalse: "setAllAddingFalse",
  setProjectMembers: "setProjectMembers",
  setCustomStatus: "setCustomStatus",
  fetchCustomStatus: "fetchCustomStatus",
  setCustomStatusById: "setCustomStatusById",
  setSidebarOpen: "setSidebarOpen",
  setCurrentTaskId: "setCurrentTaskId",
  addNewCustomStatus: "addNewCustomStatus",
  setCategories: "setCategories",
  fetchProjectCategories: "fetchProjectCategories",
  setProjectCategories: "setProjectCategories",
  fetchCompletedTaskByProjectID: "fetchCompletedTaskByProjectID",
  fetchMyTaskByProjectID: "fetchMyTaskByProjectID",
  setMainResponsible: "setMainResponsible",
  setViewType: "setViewType",
  getCategoryNames: "getCategoryNames",
  setTaskByID: "setTaskByID",
  addResponsibleTask: "addResponsibleTask",
  updateTaskByID: "updateTaskByID",
  removeLabel: "removeLabel",
  updateLabel: "updateLabel",
  updateStatus: "updateStatus",
  updateGoals: "updateGoals",
  setTaskMode: "setTaskMode",
  removeTaskByID: "removeTaskByID",
  archiveTaskByID: "archiveTaskByID",
  deleteTasks: "deleteTasks",
  addNewCategory: "addNewCategory",
  updateMe: "updateMe",
  addTaskToCategoryByID: "addTaskToCategoryByID",
  updateCategoryByID: "updateCategoryByID",
  updateBlockKeyMovement: "updateBlockKeyMovement",
  fetchTeamMembers: "fetchTeamMembers",
  updateBaseTaskByID: "updateBaseTaskByID",
  deleteCategory: "deleteCategory",
  addNewWidget: "addNewWidget",
  updateWidget: "updateWidget",
  removeWidget: "removeWidget",
  clearFilter: "clearFilter",
  setFilter: "setFilter",
  setInitialFilter: "setInitialFilter",
  setInvitePeople: "setInvitePeople",
  addTaskResponsible: "addTaskResponsible",
  removeResponsible: "removeResponsible",
  addProjectMember: "addProjectMember",
  removeProjectMember: "removeProjectMember",
  categoryUpdateStore: "categoryUpdateStore",
  setSeenNewNotifications: "setSeenNewNotifications",
  fetchAllNotifications: "fetchAllNotifications",
  addNewNotification: "addNewNotification",
  updateKanbanWidget: "updateKanbanWidget",
  updateProject: "updateProject",
  updateMeInfo: "updateMeInfo",
  updateWidgets: "updateWidgets",
  fetchMentions: "fetchMentions",
  updateNotificationSettings: "updateNotificationSettings",
  updateEmailSettings: "updateEmailSettings",
  logout: "logout",
  removeNotificationByID: "removeNotificationByID",
  updateNotification: "updateNotification",
  updateProjectMember: "updateProjectMember",
  addTeamMember: "addTeamMember",
  removeTeamMember: "removeTeamMember",
  clearSelection: "clearSelection",
  selectTask: "selectTask",
  selectCategory: "selectCategory",
  updatePremiumPlan: "updatePremiumPlan",
  projectFolder: "projectFolder",
  updateTeams: "updateTeams",
  updateTeam: "updateTeam",
  dashboard: "dashboard",
  schedulingSettings: "schedulingSettings",
  schedulingAvailability: "schedulingAvailability",
  schedulingEvents: "schedulingEvents",
  integrations: "integrations",
  invitations: "invitations",
  organization: "organization",
  requests: "requests",
};
